export default "__VITE_ASSET__Dx6Gr0xt__"